import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/connectors'

class ConnectorDataService extends RestApiDataService {}

export default new ConnectorDataService(BASE_ENTITY_URL)
